import { Action } from '@ngrx/store';
import {Account} from 'src/app/services/models/account/account.model';

export enum ELoginActions {
  LoginUsersSuccess = '[User] Login Users Success',
}

export class LoginUsersSuccess implements Action {
  public readonly type = ELoginActions.LoginUsersSuccess;
  constructor(public payload: Account) {}
}

export type LoginActions = LoginUsersSuccess;
